// removed by extract-text-webpack-plugin
module.exports = {"header":"Desktop__header__a1cGF","dropdown":"Desktop__dropdown__SW2s2","child-nav":"Desktop__child-nav__Ue0dw","subchild":"Desktop__subchild__2pwt5"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Header/Desktop/Desktop.scss
// module id = 245
// module chunks = 0